<div class="breadcrumb">
  <span class="breadcrumb-master">{{master}}</span>
  <mat-icon *ngIf="master" class="breadcrumb-icon">east</mat-icon>
  <span class="breadcrumb-parent">{{parentName}}</span>
  <mat-icon *ngIf="parentName" class="breadcrumb-icon">east</mat-icon>
  <span class="breadcrumb-name">{{name}}</span>
</div>
